<template>
  <div>
    <step :navItems="navItems" :canNext="canNext" :index="1" :step="step" v-on:step="updateStep" v-on:back="() => { this.$router.push('/group-mgr') }">
      <template slot="header">
        <h3>{{$t('add_student')}}</h3>
      </template>

      <template slot="body">
        <div class="row">
          <div class="col-sm-4 offset-sm-4">
            <form class="form-custom pt-0 bg-white">
              <label class="sr-only">{{$t('username')}}</label>
              <input type="text" class="form-control mt-3 rounded" @change="checkNecessary" :placeholder="$t('please_enter_account_required')" required v-model="student.userName">
              <span class="callout">
                {{$t('plese_enter_account_rules')}}<br/> {{$t('sample_account')}}
              </span>

              <label class="sr-only">{{$t('password')}}</label>
              <input type="password" class="form-control mt-3 rounded" @change="checkNecessary" :placeholder="$t('please_enter_password_required')" required v-model="student.password">
              <span class="callout">
                {{$t('please_enter_password_rule')}}
              </span>

              <label class="sr-only">{{$t('name')}}</label>
              <input type="text" class="form-control mt-3 rounded" @change="checkNecessary" :placeholder="$t('please_enter_name_required')" required v-model="student.realName">
              <span class="callout">
                {{$t('please_enter_students_full_name')}}
              </span>

              <label class="sr-only">{{$t('student_id')}}</label>
              <input type="text" class="form-control mt-3 rounded" :placeholder="$t('please_enter_student_ID')" required v-model="student.studentNo">
            </form>
          </div>
        </div>
      </template>
    </step>

    <step :navItems="navItems" :index="2" :step="step" v-on:step="updateStep" v-on:finish="() => { this.$router.push('/group-mgr') }">
      <template slot="header">
        <h3>{{$t('complete')}}</h3>
      </template>

      <template slot="body">
        <div class="col-8 offset-2">
          <ul class="list-group list-group-flush">
            <li class="list-group-item border text-left mb-3 rounded"
              style="line-height: 150%;">
              <span>
                {{ student.realName }}<br>{{$t('established_date')}}：{{ now }}
              </span>
              <span class="float-right"></span>
            </li>
          </ul>
        </div>
      </template>
    </step>
  </div>
</template>

<script>
import Step from './Step'
import api from '../../store/api'

export default {

  name: 'TeachingGroupAddStudent',

  components: {
    Step
  },

  data () {
    return {
      groupId: null,
      createTime: '',
      step: 1,
      student: {
        userName: '',
        password: '',
        realName: '',
        studentNo: ''
      },
      navItems: [this.$t('add_or_select'), this.$t('add_or_delete_class'), this.$t('complete')],
      canNext: false
    }
  },

  computed: {
    mode () {
      return (this.$route.name === 'group-mgr.student.add') ? 'add' : 'edit'
    },

    now () {
      let d = new Date()
      return d.getFullYear() + '-' + d.getMonth() + '-' + d.getDate()
    }
  },
  async mounted () {
    this.groupId = this.$route.params.groupId
  },

  methods: {
    updateStep (step) {
      if (step === 2) {
        this.add()
      }

      this.step = step
    },

    async add () {
      let fileData = new window.FormData()
      fileData.append('userName', this.student.userName)
      fileData.append('password', this.student.password)
      fileData.append('realName', this.student.realName)
      fileData.append('studentNo', this.student.studentNo)

      const { data } = await api.post('/GroupMgr/TeachingGroups/' + this.groupId + '/Student/Create', fileData)

      if (data.status === 'OK') {
        this.addStudentToGroup(data.data.id)
      }
    },

    async addStudentToGroup (studentId) {
      let groupForm = new window.FormData()
      groupForm.append('studentIds', [studentId])

      const { data } = await api.post('/GroupMgr/TeachingGroups/' + this.groupId + '/Students', groupForm)

      if (data.status === 'OK') {
      }
    },
    checkNecessary () {
      if (this.student.userName.length >= 6 && this.student.password.length >= 6) {
        if (this.student.userName && this.student.password && this.student.realName) {
          this.canNext = true
        } else {
          this.canNext = false
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/color.scss';

.list-group-item.active {
  background-color: $main-color;
}
.callout {
    z-index: 10;
    text-align: left;
    position: absolute;
    padding: .6em .8em;
    border-radius: .3em;
    margin: .3em 0 0 -.2em;
    background: rgb(255, 255, 255);
    border: 1px solid rgba(0,0,0,.3);
    box-shadow: .05em .2em .6em rgba(0,0,0,.2);
    font-size: 100%;
}
.callout:before {
	content: "";
	position: absolute;
	top: -.4em;
	padding: .35em;
	background: inherit;
	border: inherit;
	border-right: 0;
	border-bottom: 0;
	transform: rotate(45deg);
}
input:not(:focus) + .callout:not(:hover) {
	transform: scale(0);
	transition: .25s transform;
}

.callout {
	transition: .5s cubic-bezier(.25,.1,.3,1.5) transform;
  transform-origin: 1.4em -.4em;
  left: 20px;
}
</style>


// WEBPACK FOOTER //
// TeachingGroupAddStudent.vue?19ed9dc4